import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallLog } from '@/models/callLog';

export const fetchLiveCallLog = async (operatorId: string): Promise<CallLog | null> => {
  const response = await queryExecute({
    query: graphql(`
      query LiveCallLog($operatorId: String!) {
        liveCallLog(operatorId: $operatorId) {
          id
          fromPhoneNumber
          toPhoneNumber
          resolvedPhoneNumber
          callerId
          rideId
          operatorId
          isOnHold
          purpose
          callType
        }
      }
    `),
    variables: {
      operatorId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.liveCallLog ?? null;
};
